export default __webpack_public_path__ + "static/media/image31.8da25eae.png";